// Contenu de l'accueil refondu (novembre 2026) : cartes-modules par famille et formules.
// Les modules « bientôt » existent au catalogue (shared/catalogueModules.js) mais ne sont pas encore construits :
// ils sont affichés comme tels, jamais comme disponibles. Les prix sont ceux des formules de départ (PR « Formules de la plateforme »).

export type Famille = 'Réservation' | 'Opérations' | 'Relation client' | 'Finance' | 'IA';

export interface CarteModule {
    name: string;
    desc: string;
    famille: Famille;
    bientot?: boolean;
}

export const FAMILLES: Famille[] = ['Réservation', 'Opérations', 'Relation client', 'Finance', 'IA'];

export const CARTES_MODULES: CarteModule[] = [
    { name: 'Livre de réservations', desc: 'Plan de salle, services, acomptes, sans commission.', famille: 'Réservation' },
    { name: 'Widget de réservation', desc: 'Une balise à coller sur votre site : vos clients réservent 24 h/24.', famille: 'Réservation' },
    { name: 'RDV Pro', desc: 'Demande, acceptation et rendez-vous avec vos clients professionnels.', famille: 'Réservation' },
    { name: 'Événementiel', desc: 'Calendrier des privatisations et fiches événement.', famille: 'Réservation' },
    { name: 'Suivi privatisation', desc: "Du premier appel au devis signé, jusqu'à la clôture.", famille: 'Réservation' },
    { name: "Service d'exception", desc: "Menu unique, chiffre d'affaires prévu, message groupé aux convives.", famille: 'Réservation' },
    { name: 'Planning', desc: "Grille de la semaine, modèles d'horaires, coût, feuille de route, feuilles de présence.", famille: 'Opérations' },
    { name: 'Postes & Employés', desc: "Fiches salariés et postes. Gratuit jusqu'à 10 salariés.", famille: 'Opérations' },
    { name: 'Portail salarié & congés', desc: 'Planning, pointage, notes de frais, demandes de congé.', famille: 'Opérations' },
    { name: 'Extras', desc: 'Renforts à commander, agences partenaires, confirmation par lien.', famille: 'Opérations' },
    { name: 'Menus & Convives', desc: 'Choix des plats par les convives, allergènes, QR de table.', famille: 'Opérations' },
    { name: 'Mode terrain', desc: 'Le service en direct côté cuisine : arrivées, plats à partir.', famille: 'Opérations' },
    { name: 'Ménage par QR', desc: 'Suivi du ménage des chambres par QR code.', famille: 'Opérations', bientot: true },
    { name: 'Clients', desc: 'Fiches, historiques, factures et commandes au même endroit.', famille: 'Relation client' },
    { name: 'Ma Carte', desc: 'Votre carte en ligne, à jour, avec QR code.', famille: 'Relation client' },
    { name: 'Messagerie clients', desc: 'Répondez à vos clients depuis un seul écran.', famille: 'Relation client' },
    { name: 'Avis clients', desc: 'Collecte après le repas, modération, widget pour votre site.', famille: 'Relation client' },
    { name: 'Pub & Newsletter', desc: 'Campagnes e-mail à vos couleurs.', famille: 'Relation client' },
    { name: 'Fidélité & cartes cadeaux', desc: 'Faire revenir vos clients.', famille: 'Relation client', bientot: true },
    { name: 'Facture', desc: 'PDF, TVA, acomptes, envoi, historique, e-facturation.', famille: 'Finance' },
    { name: 'Prestations & abonnements', desc: 'Catalogue, devis en ligne, contrats signés à distance.', famille: 'Finance' },
    { name: 'Fournisseurs & commandes', desc: 'Bons de commande, confirmation par lien, réception.', famille: 'Finance' },
    { name: 'Achats & trésorerie', desc: 'Ce que vous achetez, ce qui entre et sort.', famille: 'Finance' },
    { name: 'Commerciaux & commissions', desc: "Vos apporteurs d'affaires et ce qu'on leur doit.", famille: 'Finance' },
    { name: 'Conseillère IA', desc: 'Répond à vos clients, puis passe la main à votre équipe.', famille: 'IA' },
    { name: 'Avis, rédaction assistée', desc: 'Des réponses aux avis écrites pour vous.', famille: 'IA' },
    { name: 'Agent téléphone', desc: 'Il décroche quand vous êtes en service.', famille: 'IA', bientot: true },
    { name: 'Automatisations', desc: 'Relances et rappels qui partent tout seuls.', famille: 'IA', bientot: true },
];

export interface FormuleVitrine {
    nom: string;
    prix: number;
    pour: string;
    vedette?: boolean;
}

export const FORMULES_VITRINE: FormuleVitrine[] = [
    { nom: 'Réserve', prix: 79, pour: 'Des réservations en ligne, sans commission.' },
    { nom: 'Gérer', prix: 139, pour: "Moins d'absences, des services pleins.", vedette: true },
    { nom: 'Croître', prix: 199, pour: 'Groupes, tables gastronomiques, fidélisation.' },
];

type Valeur = string | boolean;

/** Lignes du tableau comparatif : une valeur par formule (Réserve, Gérer, Croître). */
export const LIGNES_FORMULES: { label: string; valeurs: [Valeur, Valeur, Valeur]; bientot?: boolean }[] = [
    { label: 'Livre de réservations et widget', valeurs: [true, true, true] },
    { label: 'Clients (fichier et historique)', valeurs: [true, true, true] },
    { label: 'Avis clients', valeurs: [true, true, true] },
    { label: "Annuaire L'IAmani et Google Maps", valeurs: [true, true, true] },
    { label: 'Ma Carte', valeurs: [false, true, true] },
    { label: 'Avis : rédaction assistée', valeurs: [false, true, true] },
    { label: 'Instagram et Facebook', valeurs: [false, true, true] },
    { label: 'Pub & Newsletter', valeurs: [false, false, true] },
    { label: 'Conseillère IA', valeurs: [false, false, true] },
    { label: 'SMS inclus par mois', valeurs: ['100', '300', '300'] },
    { label: 'Agent téléphone', valeurs: [false, true, true], bientot: true },
    { label: 'Tableaux de bord', valeurs: [false, false, true], bientot: true },
];

// --- Exemples par métier (onglets « Voyez-le chez vous ») -------------------------------------------------------------
// Établissements fictifs, donnés comme exemples. Rien n'est promis qui n'ait pas un écran : l'hôtellerie
// affiche en « Bientôt » ce qui est encore en construction (chambres, ménage par QR, taxe de séjour).

export interface EtapeExemple { quand: string; titre: string; texte: string; module: string }
export interface ModuleExemple { nom: string; bientot?: boolean }
export interface ProfilExemple {
    cle: string;
    onglet: string;
    nom: string;
    qui: string;
    etapes: EtapeExemple[];
    modules: ModuleExemple[];
    note?: string;
}

export const PROFILS_EXEMPLES: ProfilExemple[] = [
    {
        cle: 'restaurateur', onglet: 'Restaurateur', nom: 'Brasserie Le Marronnier', qui: '120 couverts, 14 salariés, un salon privé',
        etapes: [
            { quand: 'Lundi matin', titre: 'Vous composez la semaine', texte: 'Vous remplissez la grille du planning : le coût de la semaine se calcule seul. Chaque salarié voit ses horaires sur son téléphone.', module: 'Planning' },
            { quand: 'Mardi, 23 h', titre: 'Un client réserve sans vous', texte: 'Il réserve depuis votre site. La table apparaît dans votre livre de réservations, sans commission ni appel.', module: 'Livre de réservations' },
            { quand: 'Jeudi', titre: 'Il manque 4 serveurs samedi', texte: 'Le besoin moins l\'équipe déjà affectée : le reste à commander s\'affiche. La demande part à l\'agence, qui confirme par un lien.', module: 'Extras' },
            { quand: 'Fin de mois', titre: 'La privatisation est facturée', texte: 'Du devis signé à la facture avec acompte, au même endroit que le planning de la soirée.', module: 'Facture' },
        ],
        modules: [{ nom: 'Planning' }, { nom: 'Livre de réservations' }, { nom: 'Extras' }, { nom: 'Suivi privatisation' }, { nom: 'Fournisseurs & commandes' }, { nom: 'Avis clients' }, { nom: 'Facture' }],
        note: 'Gratuit jusqu\'à 10 salariés pour le planning et l\'équipe : ici, 14 salariés, un palier.',
    },
    {
        cle: 'prestataire', onglet: 'Prestataire de service', nom: 'Éclat Nettoyage', qui: 'Nettoyage de canapés et tapis à domicile, 3 salariés en tournée',
        etapes: [
            { quand: 'Un soir, sur le site', titre: 'Le client compose son devis', texte: 'Il choisit ses prestations et voit le prix tout de suite, avec vos tarifs, vos options et vos remises.', module: 'Prestations' },
            { quand: 'Dans la foulée', titre: 'Il prend rendez-vous et verse l\'acompte', texte: 'Il choisit un créneau libre dans votre agenda. Plus de rappels par téléphone.', module: 'Planning (rendez-vous)' },
            { quand: 'Le jour J', titre: 'La tournée est dans la poche', texte: 'Vos salariés voient leurs interventions. Une fois la prestation clôturée, la facture part.', module: 'Facture' },
            { quand: 'Quelques jours après', titre: 'L\'avis arrive, l\'abonnement se propose', texte: 'Le client donne son avis, puis signe en ligne un contrat d\'abonnement annuel.', module: 'Avis clients' },
        ],
        modules: [{ nom: 'Prestations' }, { nom: 'Planning (rendez-vous)' }, { nom: 'Facture' }, { nom: 'Avis clients' }, { nom: 'Contrats d\'abonnement' }, { nom: 'Clients' }, { nom: 'Pub & Newsletter' }],
    },
    {
        cle: 'fournisseur', onglet: 'Fournisseur', nom: 'Maison Delmas', qui: 'Grossiste en fruits et légumes, 40 restaurants clients',
        etapes: [
            { quand: 'Une fois', titre: 'Vous publiez votre catalogue', texte: 'Vos produits, leur unité et leur prix, rangés par catégorie.', module: 'Catalogue produits' },
            { quand: 'Pour chaque client', titre: 'Un prix par restaurant', texte: 'Chaque restaurant voit ses prix à lui, pas ceux des autres.', module: 'Mes clients et leurs prix' },
            { quand: 'Chaque soir', titre: 'Les commandes arrivent', texte: 'Le restaurant commande depuis son espace. Vous confirmez, et la confirmation lui arrive.', module: 'Commandes reçues' },
        ],
        modules: [{ nom: 'Catalogue produits' }, { nom: 'Mes clients et leurs prix' }, { nom: 'Commandes reçues' }],
        note: 'Du côté du restaurant, ces commandes arrivent dans « Fournisseurs & commandes ».',
    },
];
